/* This component CREATES one entry for the historys collection in MongoDB.
   As the entry is being CREATED, it should then activate the HistoryRead component
   to show the entry as it is being built. */

import React, { useState }                      from 'react'
import Box                                      from "@material-ui/core/Box"
import Grid                                     from '@material-ui/core/Grid'
import GuestBioCreateComponent                  from '../Components/GuestBioCreateComponent'
import HistoryCitationCreateComponent           from '../Components/HistoryCitationCreateComponent'
import HistoryCreateComponent                   from '../Components/HistoryCreateComponent'
import InfoComponent                            from '../Components/InfoComponent'
import PilotCohortSourceCreateComponent         from '../Components/PilotCohortSourceCreateComponent'
import RadioOptionComponent                     from '../Components/RadioOptionComponent'
import { historyEntryTypeRadioOptions }         from '../config'
import Typography                               from '@material-ui/core/Typography'

const HistoryCreatePage = () => {

   const [ guestBioEntry,                       setGuestBioEntry                 ]  =  useState(false)
   const [ historyCitation,                     setHistoryCitation               ]  =  useState(false)
   const [ historyEntry,                        setHistoryEntry                  ]  =  useState(false)
   const [ pilotCohortSourceTableEntry,         setPilotCohortSourceTableEntry   ]  =  useState(false)
   const [ showInfoComponent,                   setShowInfoComponent             ]  =  useState(true)

   const info = [
      'History entries are the main entries on the History Page.',
      'If a historical entry is for a class between 1944 and 1949 then a Pilot / Cohort / Source Table should be entered first.',
      'If a historical entry will also have a Guest Bio, that should be enterted before the historical entry as well.',
      'History Citations can be added after the fact.'
   ]

   const closeComponent = () => {
      setShowInfoComponent(false)
   }

   const getOption = (o) => {
      switch (o) {
         case 'Guest Bio Entry':
            setGuestBioEntry(true)
         break
         case 'History Citation':
            setHistoryCitation(true)
         break
         case 'History Entry':
            setHistoryEntry(true)
         break
         case 'Pilot / Cohort / Source Table':
            setPilotCohortSourceTableEntry(true)
         break
      }
      closeComponent()
   }

   return (
      <Box>
         { showInfoComponent ? <InfoComponent closeComponent={closeComponent} info={info} /> : null }
         {guestBioEntry || historyEntry || historyCitation || pilotCohortSourceTableEntry
            ?
               null
            :
               <Grid style={{ marginTop: '6rem' }} >
                  <Typography variant='h4' >
                     Create Page
                  </Typography>
                  <RadioOptionComponent getOption={getOption} options={historyEntryTypeRadioOptions} />
               </Grid>
         }
         {guestBioEntry                ?  <GuestBioCreateComponent />            :  null}
         {historyCitation              ?  <HistoryCitationCreateComponent />     :  null}
         {historyEntry                 ?  <HistoryCreateComponent />             :  null}
         {pilotCohortSourceTableEntry  ?  <PilotCohortSourceCreateComponent />   :  null}
      </Box>
   )
}

export default HistoryCreatePage
